<template>
	<div class="modal-card browse-explorer" style="width: auto; min-width: 680px">
		<header class="modal-card-head">
			<p class="modal-card-title">Image Explorer</p>
		</header>
		<section class="modal-card-body">
			<o-field label="Upload new image" class="file is-block">
				<o-upload v-model="file" :disabled="loading" native accept=".jpg,.png,.bmp,.gif">
					<o-button tag="a" variant="primary">
						<o-icon icon="upload"></o-icon>
						<span>Upload</span>
					</o-button>
				</o-upload>
				<template #message>Optimal image size - 800 x 800</template>
			</o-field>

			<div>
				<o-field label="Search existing">
					<o-input
						v-model="search"
						placeholder="Search.."
						clearable
						@input="DebounceAssets(300)"></o-input>
				</o-field>
				<card title="Images" layout="table">
					<loading v-if="loading"></loading>
					<o-table :data="list" hoverable :defaultSort="['Title', 'asc']">
						<template #empty>No results, please adjust your search</template>
						<template v-slot:default>
							<o-table-column field="UUID" label="" v-slot="props">
								<item-image type="image" :uuid="props.row.UUID" class="limit-width"></item-image>
							</o-table-column>
							<o-table-column field="Title" label="Filename" sortable v-slot="props">
								{{ props.row.Title }}
							</o-table-column>
							<o-table-column field="Type.Identifier" label="Type" v-slot="props">
								{{ props.row.Type.Identifier }}
							</o-table-column>
							<o-table-column v-slot="props" position="right">
								<o-button @click="Select(props.row)">Select</o-button>
							</o-table-column>
						</template>
					</o-table>
				</card>
			</div>
		</section>
		<footer class="modal-card-foot">
			<o-button variant="light" @click="Close">Cancel</o-button>
		</footer>
	</div>
</template>
<script>
	import { ref, computed, inject, onMounted, watch } from "vue";
	import store from "@/store";
	import currencyFormat from "@/services/utils/currencyFormat";
	import { itemImage } from "@/components/webComponents";
	export default {
		components: {
			itemImage
		},
		emits: ["select"],
		setup(props, context) {
			const $http = inject("$http");
			const $error = inject("$error");

			const list = ref([]);
			const selection = ref();
			const search = ref("");
			const file = ref();

			const loading = ref(false);

			const GetAssets = async () => {
				try {
					loading.value = true;
					const qs = "?search=" + search.value;
					const response = await $http.get("/api/v2/webComand/assets" + qs);
					list.value = response.data;
					loading.value = false;
				} catch (err) {
					$error("Failed to get assets");
					loading.value = false;
				}
			};

			const UploadFile = async () => {
				loading.value = true;

				const formData = new FormData();
				formData.append("file", file.value);
				try {
					const response = await $http.post("/api/v2/webComand/assets", formData);

					Select(response.data);
					loading.value = false;
				} catch (err) {
					$error("Failed to upload");
				}

				file.value = null;
				GetAssets();
			};

			let running = false;
			let rerun = false;
			let debouncer = null;
			const DebounceAssets = (timeout) => {
				//Only the last debounce is executed when promise is pending.
				const debounceFn = async function () {
					if (!running) {
						running = true;
						await GetAssets();
						running = false;
						if (rerun) {
							DebounceAssets();
						}
					} else {
						rerun = true;
					}
				};
				clearTimeout(debouncer);
				debouncer = setTimeout(debounceFn, timeout);
			};

			const Close = () => {
				context.emit("close");
			};

			const Select = (row) => {
				selection.value = row;
				context.emit("select", selection.value);
				context.emit("close");
			};

			watch(
				() => file.value,
				(n) => {
					if (n) {
						UploadFile();
					}
				}
			);

			onMounted(async () => {
				running = true;
				GetAssets();
				running = false;
			});

			return {
				loading,
				list,
				search,
				file,
				selection,
				DebounceAssets,
				UploadFile,
				Close,
				Select
			};
		}
	};
</script>
<style lang="scss">
	.browse-explorer {
		& .limit-width {
			max-width: 150px;
		}
	}
</style>
